<div class="filter">
  <div
    *ngIf="filterStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'statuses'"
      [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterCurrency"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'currencies'"
      [filter]="filterCurrency">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterP2p"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'p2p'"
      [filter]="filterP2p">
    </app-filter-select>
  </div>
</div>
